import Http from "@/common/plugin/Http";
import { GetInstanceFirstParam } from "@/common/util/types";
import { transformResponseCenter, transformRequestCenter } from "./common/util/transform";
import { AChaiSdk } from "./common/sdk/AChaiSdk";
import { ClientSdk } from "./common/sdk/ClientSdk";
import { platformAdpter } from "./common/util/adpter";
import { V2ClientSdk } from "./common/v2sdk/V2ClientSdk";
import { V2FanjuClientSdk } from "./common/v2sdk/V2FanjuSdk";
import { AllPlatformSdk } from "./common/sdk/AllPlatformSdk";

interface AYAppConfig {
    /**
     * 请求库
     */
    axios: GetInstanceFirstParam<typeof Http>;
    /**
     * v1版本sdk
     * 暂停维护
     */
    sdk: ClientSdk;
    /**
     * v2版本sdk
     * 持续维护
     */
    v2sdk: V2ClientSdk;
}

const baseURL = process.env.VUE_APP_CDN_PATH !== 'prod' ? 'https://la-test-ad-service.aiyouaiyou.cn' : '//la-ad-service.aiyouaiyou.cn';


// const baseURL = process.env.VUE_APP_CDN_PATH !== 'prod' ? 'http://192.168.10.220:5129' : '//la-ad-service.aiyouaiyou.cn';


export const appConfig: AYAppConfig = {
    // sdk配置
    sdk: new AllPlatformSdk(),
    // v2sdk配置
    v2sdk: new V2FanjuClientSdk(),
    // axios配置
    axios: platformAdpter<GetInstanceFirstParam<typeof Http>>({
        ios: () => ({
            baseURL: baseURL,
            requestInterceptors: [],
            responseInterceptors: [transformResponseCenter],
        }),
        android: () => ({
            baseURL: baseURL,
            requestInterceptors: [],
            responseInterceptors: [transformResponseCenter],
        }),
        harmony: () => ({
            baseURL: baseURL,
            requestInterceptors: [],
            responseInterceptors: [transformResponseCenter],
        }),
    }),
}
